<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="vinculations"
        :items-per-page="15"
        :footer-props="{
          itemsPerPageOptions: [15, 30, -1],
          itemsPerPageText: $t('table.itemsPerPageText')
        }"
        sort-by="name"
        class="table-cursor"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="700px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  >{{ $t("button.newVinculation") }}</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-form ref="form">
                      <v-row>
                        <v-col cols="12">
                          <v-autocomplete
                            v-model="editedItem.category"
                            :items="categories"
                            item-text="internal_name"
                            item-value="id"
                            :return-object="false"
                            :label="$t('form.category')"
                            :rules="rules.fieldRequired"
                            hide-details
                            clearable
                          ></v-autocomplete
                        ></v-col>
                        <v-col cols="12">
                          <v-select
                            v-model="editedItem.type"
                            :items="vinculationTypes"
                            item-value="value"
                            item-text="text"
                            :label="$t('type')"
                            :rules="rules.fieldRequired"
                            hide-details
                          ></v-select
                        ></v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-menu
                            v-model="menu_start_date"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="editedItem.start_date"
                                :label="$t('label.startDate')"
                                prepend-inner-icon="event"
                                readonly
                                v-on="on"
                                :rules="rules.fieldRequired"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="editedItem.start_date"
                              @input="menu_start_date = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                          <v-menu
                            v-model="menu_end_date"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="editedItem.end_date"
                                :label="$t('label.endDate')"
                                prepend-inner-icon="event"
                                readonly
                                v-on="on"
                                :rules="rules.fieldRequired"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              :min="editedItem.start_date"
                              v-model="editedItem.end_date"
                              @input="menu_end_date = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="close">{{ $t("button.cancel") }}</v-btn>
                  <v-btn color="primary" @click="save">{{
                    $t("button.save")
                  }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.categoryName="{ item }">
          <span>{{ getNameCategory(item.category) }}</span>
        </template>
        <template v-slot:item.type="{ item }">
          <span>{{ $t('vinculation.types.' + item.type) }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="table-actions-nowrap">
            <v-btn icon small color="primary" @click="editItem(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon small color="red" @click="deleteItem(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import validationRules from "../../../mixins/validationRules";
import investigator_model from "../../../mixins/model_utils/investigator_model";
export default {
  mixins: [validationRules, investigator_model],
  props: {
    person: String
  },
  data() {
    return {
      menu_start_date: false,
      menu_end_date: false,
      dialog: false,
      vinculations: [],
      editedIndex: -1,
      editedItem: {
        category: null,
        type: null,
        start_date: null,
        end_date: null
      },
      defaultItem: {
        category: null,
        start_date: null,
        end_date: null
      }
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("button.newVinculation")
        : this.$t("title.editVinculation");
    },
    headers() {
      return [
        {
          text: this.$t("form.category"),
          value: "categoryName"
        },
        {
          text: this.$t("type"),
          value: "type"
        },
        {
          text: this.$t("label.startDate"),
          value: "start_date"
        },
        {
          text: this.$t("label.endDate"),
          value: "end_date"
        },
        {
          text: this.$t("actions"),
          value: "actions",
          align: "end",
          width: 96,
          filterable: false,
          sortable: false
        }
      ];
    }
  },
  created() {
    this.getCategories();
    this.getVinculationTypes();
    this.initialize();
  },

  methods: {
    initialize() {
      let path = this.$store.state.endpoint + "/vinculation";
      axios
        .get(path)
        .then(response => {
          this.vinculations = response.data.filter(
            item => item.person.toString() === this.person
          );
        })
        .catch(error => {
          console.log(error);
        });
    },

    getNameCategory(id) {
      let category = this.categories.find(category => category.id === id);
      if (category !== undefined) {
        return category.internal_name;
      }
      return "";
    },

    editItem(item) {
      this.editedIndex = this.vinculations.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.id = item.id;
      this.dialog = true;
    },

    deleteItem(item) {
      if (confirm(this.$t("message.confirm.delete"))) {
        let path = this.$store.state.endpoint + "/vinculation/" + item.id;
        axios
          .delete(path)
          .then(response => {
            const index = this.vinculations.indexOf(item);
            this.vinculations.splice(index, 1);
            this.$store.commit("alert", {
              color: "success",
              text: this.$t("message.correct.deleteItem")
            });
          })
          .catch(error => {
            console.log(error);
            this.$store.commit("alert", {
              color: "error",
              text: error.response
            });
          });
      }
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form.reset();
      });
    },

    save() {
      if (this.$refs.form.validate()) {
        let path;
        const index = this.editedIndex;
        const data = this.editedItem;
        if (index > -1) {
          path =
            this.$store.state.endpoint + "/vinculation/" + this.editedItem.id;
          axios
            .patch(path, this.editedItem)
            .then(response => {
              Object.assign(this.vinculations[index], data);
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.updateItem")
              });
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        } else {
          path = this.$store.state.endpoint + "/vinculation";
          const data = this.editedItem;
          data["person"] = this.person;
          axios
            .post(path, data)
            .then(response => {
              data.id = response.data.id;
              this.vinculations.push(data);
              this.$store.commit("alert", {
                color: "success",
                text: this.$t("message.correct.createItem")
              });
            })
            .catch(error => {
              console.log(error);
              this.$store.commit("alert", {
                color: "error",
                text: error.response.data
              });
            });
        }
        this.close();
      }
    }
  }
};
</script>
<style scoped>
.table-actions-nowrap {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  white-space: nowrap;
  min-width: 72px;
}
</style>
